import {Product, Variation} from '@sportngin/se-commerce-sdk/models/clare';

function resolveDefaultVariation(product: Product): Variation | undefined {
  const legacyItem = product.item;
  const variations = product.variations ?? [];
  const requestedDefaultVariationId =
    legacyItem?.default_variation_id ??
    product.default_variation_id ??
    legacyItem?.default_variation?.id ??
    product.default_variation?.id;
  const matchedDefaultVariation = requestedDefaultVariationId
    ? variations.find(variation => variation.id === requestedDefaultVariationId)
    : undefined;

  return (
    legacyItem?.default_variation ??
    product.default_variation ??
    matchedDefaultVariation ??
    variations[0]
  );
}

/**
 * Normalizes products-endpoint DTOs so downstream UI-model mapping uses the
 * purchasable item identity/default variation rather than the catalog product
 * wrapper identity.
 */
export function normalizeCatalogProduct(product: Product): Product {
  const legacyItem = product.item;
  const defaultVariation = resolveDefaultVariation(product);
  const id =
    legacyItem?.id ??
    product.display_metadata?.item_id ??
    defaultVariation?.item_id ??
    product.id;
  const uuid =
    legacyItem?.uuid ??
    product.uuid ??
    defaultVariation?.uuid ??
    `catalog-${id ?? 'unknown'}`;

  return {
    ...product,
    id,
    uuid,
    default_variation: defaultVariation,
    default_variation_id:
      defaultVariation?.id ??
      legacyItem?.default_variation_id ??
      product.default_variation_id,
  };
}
